import { Textarea as BaseTextArea, TextareaProps } from "baseui/textarea";
import { ChangeEvent } from "react";
import React from "react";
import { Controller, UseControllerProps } from "react-hook-form";
import { StyleObject } from "styletron-react";

type Props = {
  $style?: StyleObject;
} & TextareaProps;

const TextArea = ({ $style, ...rest }: Props): React.ReactElement => {
  return (
    <BaseTextArea
      size="compact"
      overrides={
        {
          Root: {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            style: ({ $theme }: any) => ({
              borderTopLeftRadius: $theme.borders.radius200,
              borderTopRightRadius: $theme.borders.radius200,
              borderBottomRightRadius: $theme.borders.radius200,
              borderBottomLeftRadius: $theme.borders.radius200,
            }),
          },
          Input: {
            style: {
              backgroundColor: "transparent",
              ":-webkit-autofill": {
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
              },
              ...$style,
            },
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } as any
      }
      rows={5}
      {...rest}
    />
  );
};

export default TextArea;

export function ControlledTextArea({
  control,
  name,
  rules,
  ...rest
}: UseControllerProps<any> & Props): React.ReactElement {
  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field: { onChange, onBlur, value, name } }) => (
        <TextArea
          onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
            onChange(e.target.value)
          }
          onBlur={onBlur}
          value={value}
          name={name}
          id={name}
          {...rest}
        />
      )}
    />
  );
}
